import { FC } from 'react';
import { Field } from 'react-final-form';
import { required } from '../../helpers';
import useFetchCountries from '../../hooks/useFetchCountries';
import FormError from './FormError';

type Location = {
  address?: string;
  city: string;
  country: number;
  state: number;
};

type Props = {
  label: string;
  addressFormName?: string;
  cityFormName: string;
  stateFormName: string;
  countryFormName: string;
  readOnly?: boolean;
  payload?: Location;
  countryId?: number;
};

const LocationWithAddress: FC<Props> = ({ label, addressFormName, cityFormName, stateFormName, countryFormName, readOnly, payload, countryId }) => {
  const { countries, provinces, handleSelectCountry } = useFetchCountries(countryId);

  return (
    <>
      <label className='form-label'>{label}</label>
      {addressFormName && (
        <div className='mb-2 col-lg-12'>
          <Field name={addressFormName} type='text' validate={readOnly ? undefined : (v) => required(v, 'Address')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  {!readOnly && <input type='text' {...input} placeholder='Address' className='form-control form-control-lg form-control-solid' />}
                  {readOnly && <input type='text' {...input} placeholder='Address' className='form-control form-control-lg form-control-solid' readOnly />}
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>
      )}

      <div className='mb-2 col-lg-12'>
        <Field name={cityFormName} type='text' validate={readOnly ? undefined : (v) => required(v, 'City')}>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                {!readOnly && <input type='text' placeholder='City' {...input} className='form-control form-control-lg form-control-solid' />}
                {readOnly && <input type='text' placeholder='City' {...input} className='form-control form-control-lg form-control-solid' readOnly />}
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>

      <div className='row'>
        <div className='mb-2 col-lg-6'>
          <Field name={countryFormName} type='select' validate={readOnly ? undefined : (v) => required(v, 'Country')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <select
                    {...input}
                    className='form-select form-select-lg form-select-solid'
                    onChange={(e) => {
                      input.onChange(e);
                      handleSelectCountry(e);
                    }}
                    disabled={readOnly}>
                    <option value='' defaultValue='' disabled hidden>
                      {payload?.country && readOnly ? payload.country : 'Country'}
                    </option>
                    {countries.length > 0 &&
                      !readOnly &&
                      countries.map((country) => {
                        return (
                          <option key={country.id} value={country.id}>
                            {country.name}
                          </option>
                        );
                      })}
                  </select>
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>
        <div className='mb-2 col-lg-6'>
          <Field name={stateFormName} type='select' validate={readOnly ? undefined : (v) => required(v, 'State/Province')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <select {...input} className='form-select form-select-lg form-select-solid' disabled={readOnly}>
                    <option value='' defaultValue=''>
                      {payload?.state && readOnly ? payload.state : 'State/Province'}
                    </option>
                    {provinces.length > 0 &&
                      !readOnly &&
                      provinces.map((state) => {
                        return (
                          <option key={state.id} value={state.id}>
                            {state.name}
                          </option>
                        );
                      })}
                  </select>
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>
      </div>
    </>
  );
};

export default LocationWithAddress;
